import React from "react";
import { Box } from "@mui/material";
import CommunityHome from "../components/community/CommunityHome";
import { useSportWorkspace } from "../hooks/useSportWorkspace";

const Community = () => {
  const { sport } = useSportWorkspace();
  return (
    <Box sx={{ py: { xs: 1, sm: 2 }, maxWidth: 960, mx: "auto" }}>
      <CommunityHome sport={sport} />
    </Box>
  );
};

export default Community;
